import { useI18n } from 'vue-i18n'
import storageKey from "@/constant/storage_key";
import storage from "@/utils/local_storage";

export default function useToggleLanguage() {
    const { locale } = useI18n()

    const onToggleLanguage = () => {
        switch(locale.value) {
            case "zh":
                locale.value = "en";
                storage.set(storageKey.USER_LANGUAGE_KEY, 'en')
                break;
            case "en":
                locale.value = "zh";
                storage.set(storageKey.USER_LANGUAGE_KEY, 'zh')
                break;
            default: break;
        }
    }

    return { onToggleLanguage }
}